//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import DashboardLayout from "../layouts/DashboardLayout";
import PrivateRoute from "./PrivateRoute";
//@ts-ignore
import Overview from "../pages/Overview";
import DataCollectionList from "../pages/DataCollection/DataCollectionList";
import FormsList from "../pages/Forms/FormsList";
//@ts-ignore
import { WelcomeRouterService } from "@careinfo/welcome-page-service";
import { getKey } from "../helpers/sessionKey";
import CreateForms from "../pages/Forms/CreateForms";
import PinnedFormData from "../pages/PinnedFormData";
import WizardList from "../pages/Wizard/WizardList";

const Router = () => {
  const shouldShowWelcome = getKey("shouldShowWelcome");
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path="/form-builder/overview" element={<Overview />} />
        <Route
          path={"/form-builder"}
          element={
            shouldShowWelcome === "true" || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <Overview />
            )
          }
        />
        <Route path="/form-builder/forms" element={<FormsList />} />
        <Route
          path="/form-builder/data-collect/:formId"
          element={<PinnedFormData />}
        />
        <Route path="/form-builder/forms/create" element={<CreateForms />} />
        <Route
          path="/form-builder/data-collected/"
          element={<DataCollectionList />}
        />
        <Route path="/form-builder/wizards" element={<WizardList />} />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
